import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { parseQueryParams } from "../../../libs/Util";
import SelectClass from "../../../templates/Select/Class";
import {
  activeLearningRetrospectPath,
  Context,
  fetchClasses,
  fetchKlassIdsWithActiveLearningMaterials,
  lessonRetrospectPath,
} from "../../../teacherStore";
import { EFFECTIVE_YEAR } from "../../../constants/year";

export default () => {
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const queryParams = parseQueryParams();
  const classListInParams = queryParams["classList"];
  const isActiveLearningParam = queryParams["isActiveLearning"] === "true";
  const classes = isActiveLearningParam
    ? state.klass_ids_with_active_learning_materials
    : state.classes;

  useEffect(() => {
    dispatch(fetchClasses());
    dispatch(fetchKlassIdsWithActiveLearningMaterials());
  }, [dispatch]);

  const selectedClassIds: number[] = useMemo(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  const selectedClasses = useMemo(
    () => classes.filter(c => selectedClassIds.includes(c.id)),
    [classes, selectedClassIds],
  );

  const replacePath = useCallback(
    (ids: number[]) => {
      const activeLearningParam = isActiveLearningParam
        ? "&isActiveLearning=true"
        : "";

      history.replace(
        `${lessonRetrospectPath}?classList=${ids.join(
          ",",
        )}${activeLearningParam}`,
      );
    },
    [history, isActiveLearningParam],
  );

  const selectClass = (id: number) => {
    const ids = classes
      .filter(cls => cls.id === id || selectedClassIds.includes(cls.id))
      .map(cls => cls.id);
    replacePath(ids);
  };

  const removeClass = (id: number) => {
    const ids = selectedClassIds.filter(clsId => clsId !== id);
    replacePath(ids);
  };

  const goToLessonRetrospectWithSelectedClasses = useCallback(() => {
    if (!isActiveLearningParam) return; // 基礎編はonemenu側で管理

    const classListIds = selectedClassIds.join(",");
    const classListParam = `?classList=${classListIds}`;
    const path = `${activeLearningRetrospectPath}${classListParam}`;
    history.push(path);
  }, [history, isActiveLearningParam, selectedClassIds]);

  return (
    <SelectClass
      classes={classes}
      isMultiSelect
      selectedClassIds={selectedClassIds}
      selectedClasses={selectedClasses}
      onChooseClass={id => {
        if (selectedClassIds.includes(id)) {
          removeClass(id);
        } else {
          selectClass(id);
        }
      }}
      onRemoveClass={removeClass}
      proceedWithSelectedClasses={goToLessonRetrospectWithSelectedClasses}
      isShowExchangeYearLink={
        state.is_manager && state.current_year < EFFECTIVE_YEAR
      }
    />
  );
};
